import * as AuthActions from "./auth";
import * as OrganizationsActions from "./organizations";
import * as EditorActions from "./editor";
import * as MapEditorActions from "./editor";
import * as ProjectActions from "./projects";
import * as MapActions from "./map";
import * as HistoryActions from "./history";
import * as InspectorActions from "./inspector";

const ActionCreators = Object.assign(
  {},
  AuthActions,
  OrganizationsActions,
  EditorActions,
  MapEditorActions,
  ProjectActions,
  MapActions,
  HistoryActions,
  InspectorActions
);

export default ActionCreators;



// WEBPACK FOOTER //
// ./src/redux/actions/index.js